export default __webpack_public_path__ + "static/media/48.117701d0.jpg";